import { render, staticRenderFns } from "./OpenRtaList.vue?vue&type=template&id=206c2589&scoped=true&"
import script from "./OpenRtaList.vue?vue&type=script&lang=js&"
export * from "./OpenRtaList.vue?vue&type=script&lang=js&"
import style0 from "./OpenRtaList.vue?vue&type=style&index=0&id=206c2589&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c2589",
  null
  
)

export default component.exports